import { UserRegionContext } from 'flow/contexts/UserRegionProvider';
import { useContext } from 'react';

export const useUserRegionData = () => {
    const regionContext = useContext(UserRegionContext);

    if (!regionContext) {
        throw new Error(
            'useUserRegionData must be used within a UserRegionProvider',
        );
    }

    return regionContext;
};
